var _path, _g, _path2, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconPlanesAccion(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_101_6877",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 25,
    height: 25
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 20V22.5H22.5V20H20ZM2.5 2.5V5H5V2.5H2.5ZM2.5 20V22.5H5V20H2.5ZM7.5 2.5H18.75V5H7.5V7.5H0V0H7.5V2.5ZM17.5 20V17.5H20V6.25H22.5V17.5H25V25H17.5V22.5H7.5V25H0V17.5H7.5V20H17.5Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_101_6877)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.125 -3.125H-3.125V28.125H28.125V-3.125Z",
    fill: "#2E2F30"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_101_6877",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 17,
    y: 0,
    width: 8,
    height: 8
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.25 0C23.3187 0 25 1.68125 25 3.75C25 5.81875 23.3187 7.5 21.25 7.5C19.1813 7.5 17.5 5.81875 17.5 3.75C17.5 1.68125 19.1813 0 21.25 0ZM21.25 2.5C20.5625 2.5 20 3.0625 20 3.75C20 4.4375 20.5625 5 21.25 5C21.9375 5 22.5 4.4375 22.5 3.75C22.5 3.0625 21.9375 2.5 21.25 2.5Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_101_6877)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.125 -3.125H14.375V10.625H28.125V-3.125Z",
    fill: "#2E2F30"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPlanesAccion);
export default __webpack_public_path__ + "static/media/icon-planes-accion.3ef1726ac3263873a3143604b1de3f2a.svg";
export { ForwardRef as ReactComponent };